export class SaleStatusTypeSelector {
  private el: HTMLSelectElement;
  private rowData: {[propName: string]: any} = {};
  private disabled: boolean = false;
  private constructor(props: any) {
    this.rowData = props.grid.store.data.rawData[props.rowKey];
    const beforeApprovalStatus = ['REGISTRATION_READY', 'APPROVAL_READY', 'APPROVAL_REJECTION', 'SALE_AGREEMENT_READY', 'SALE_AGREEMENT_REJECTION'];
    if (
      (beforeApprovalStatus.includes(this.rowData.applyStatusType) || this.rowData.applyStatusType === 'SALE_AGREEMENT_READY') &&
      !(this.rowData.applyStatusType !== 'REGISTRATION_READY' && this.rowData.saleStatusType === 'ON_PRE_SALE')
    ) {
      this.disabled = true;
    }

    switch (this.rowData.saleStatusType) {
      case 'END_SALE':
      case 'WAITING_SALE':
        this.disabled = true;
        break;
    }

    if (this.rowData.saleSettingStatusType === 'PROHIBITION_SALE') {
      this.disabled = true;
    }

    const listItems = props.columnInfo.editor.options.listItems;
    const select = document.createElement('select');
    for (var i = 0; i < listItems.length; i++) {
      const option = document.createElement('option');
      option.value = listItems[i].value;
      option.text = listItems[i].text;
      if (this.rowData.saleStatusType === option.value) {
        option.selected = true;
      }
      select.appendChild(option);
    }
    select.value = this.rowData.saleStatusType;

    this.el = select;
    this.el.disabled = this.disabled;
  }

  public getElement(): HTMLSelectElement {
    return this.el;
  }

  public getValue(): string {
    return this.el.value;
  }

  private mounted(): void {}
}

export class FrontDisplayableSelector {
  private el: HTMLSelectElement;
  private rowData: {[propName: string]: any} = {};
  private disabled: boolean = false;
  private constructor(props: any) {
    this.rowData = props.grid.store.data.rawData[props.rowKey];
    const frontDisplayable = String(this.rowData.frontDisplayable);

    if (this.rowData.saleSettingStatusType === 'PROHIBITION_SALE') {
      this.disabled = true;
    }

    const listItems = props.columnInfo.editor.options.listItems;
    const select = document.createElement('select');
    for (var i = 0; i < listItems.length; i++) {
      const option = document.createElement('option');
      option.value = String(listItems[i].value);
      option.text = listItems[i].text;
      if (frontDisplayable === option.value) {
        option.selected = true;
      }
      select.appendChild(option);
    }

    this.el = select;
    this.el.disabled = this.disabled;
  }

  public getElement(): HTMLSelectElement {
    return this.el;
  }

  public getValue(): string {
    return this.el.value;
  }
}

export class OnlyAccessUrlSelector {
  private el: HTMLSelectElement;
  private rowData: {[propName: string]: any} = {};
  private disabled: boolean = false;
  private constructor(props: any) {
    this.rowData = props.grid.store.data.rawData[props.rowKey];
    const onlyAccessUrl = String(this.rowData.onlyAccessUrl);
    if (this.rowData.saleSettingStatusType === 'PROHIBITION_SALE') {
      this.disabled = true;
    }

    const listItems = props.columnInfo.editor.options.listItems;
    const select = document.createElement('select');
    for (var i = 0; i < listItems.length; i++) {
      const option = document.createElement('option');
      option.value = String(listItems[i].value);
      option.text = listItems[i].text;
      if (onlyAccessUrl === option.value) {
        option.selected = true;
      }
      select.appendChild(option);
    }

    this.el = select;
    this.el.disabled = this.disabled;
  }

  public getElement(): HTMLSelectElement {
    return this.el;
  }

  public getValue(): string {
    return this.el.value;
  }
}

export class MemberGradeDisplayInfoRenderer {
  private el: any;
  private rowData: {[propName: string]: any} = {};
  private constructor(props: any) {
    this.rowData = props.grid.store.data.rawData[props.rowKey];
    const value = this.rowData.memberGradeDisplayInfo;

    if (value.check === 'NONE') {
      this.el = document.createElement('div');
      this.el.innerHTML = window.$t('PRODUCT_PRODUCTLIST_NOT_SET'); //설정안함
    } else {
      const {check, info} = value;
      this.el = document.createElement('button');
      this.el.type = 'button';
      this.el.classList.add('memberDisplay');
      this.el.setAttribute('data-type', 'Grade');
      this.el.setAttribute('data-check', check);
      this.el.setAttribute('data-info', JSON.stringify(info));
      this.el.setAttribute('data-mall-no', this.rowData.mallNo);
      // this.el.addEventListener('click', (ev: any): void => {
      //   ev.stopPropagation();
      // });
      this.el.innerHTML = window.$t('PRODUCT_PRODUCTLIST_VIEW_SETTINGS'); //설정보기
    }
    // this.render(props);
  }

  public getElement(): HTMLButtonElement {
    return this.el;
  }

  // public render(props: any): any {
  //   return this.el.value = String(props.value);
  // }
}

//memberGroupDisplayInfo
export class MemberGroupDisplayInfoRenderer {
  private el: any;
  private rowData: {[propName: string]: any} = {};
  private constructor(props: any) {
    this.rowData = props.grid.store.data.rawData[props.rowKey];
    const value = this.rowData.memberGroupDisplayInfo;

    if (value.check === 'NONE') {
      this.el = document.createElement('div');
      this.el.innerHTML = window.$t('PRODUCT_PRODUCTLIST_NOT_SET'); //설정안함
    } else {
      const {check, info} = value;
      this.el = document.createElement('button');
      this.el.type = 'button';
      this.el.classList.add('memberDisplay');
      this.el.setAttribute('data-type', 'Group');
      this.el.setAttribute('data-check', check);
      this.el.setAttribute('data-info', JSON.stringify(info));
      this.el.setAttribute('data-mall-no', this.rowData.mallNo);
      // this.el.addEventListener('mousedown', (ev: any): void => {
      //   ev.stopPropagation();
      // });
      this.el.innerHTML = window.$t('PRODUCT_PRODUCTLIST_VIEW_SETTINGS'); //설정보기
    }
  }

  public getElement(): HTMLButtonElement {
    return this.el;
  }
}

export class ProductNameEditor {
  private el: any;
  private rowData: {[propName: string]: any} = {};
  private constructor(props: any) {
    this.rowData = props.grid.store.data.rawData[props.rowKey];
    let disabled = false;
    const {saleSettingStatusType} = this.rowData;
    if (saleSettingStatusType === 'PROHIBITION_SALE') {
      disabled = true;
    }
    const el = document.createElement('input');
    // const {maxLength} = props.columnInfo.editor.options;

    el.type = 'text';
    // el.maxLength = maxLength;
    el.value = String(props.value);
    el.disabled = disabled;

    this.el = el;
  }

  public getElement(): HTMLInputElement {
    return this.el;
  }

  public getValue(): string {
    return this.el.value;
  }

  private mounted(): void {
    this.el.select();
  }
}
